<template>
  <div class="scrollContainer" ref="scrollContainer" :style="domStyle">
    <div class="scrollWrapper" ref="">
      <slot></slot>
    </div>
  </div>
</template>

<script>
import BScroll from '@better-scroll/core'
import Pullup from '@better-scroll/pull-up'
BScroll.use(Pullup)

export default {
  data() {
    return {
      bs: null,
      domStyle: { bottom: 0 }
    }
  },
  methods: {
    setBs() {
      this.bs = new BScroll(this.$refs.scrollContainer, {
        scrollY: true,
        scrollX: false,
        pullUpLoad: true,
        click: true
      })
      this.bs.on('pullingUp', () => {
        this.$emit('callBack')
      })
      this.bs.on('scroll', e => {
        this.$emit('scrollFn', e)
      })
    },
    scrollTo(x, y, time, easing, extraTransform) {
      this.bs.scrollTo(x, y, time, easing, extraTransform)
    }
  }
}
</script>

<style lang="scss" scoped>
.scrollContainer {
  width: 750px;
  margin: 0 auto;
}
.scrollWrapper {
  overflow: hidden;
}
</style>
